import React from 'react';
import NotSupportedImg from '@assets/icons/AssetPlaceholder/NotSupportedPlaceHolder-v2.svg?url';
import AudioPlaceHolder from '@assets/icons/AssetPlaceholder/AudioPlaceHolder-v2.svg?url';
import VideoPlaceHolder from '@assets/icons/AssetPlaceholder/VideoPlaceHolder-v2.svg?url';
import DocumentPlaceHolder from '@assets/icons/AssetPlaceholder/DocumentPlaceHolder-v2.svg?url';
import WebsitePlaceHolder from '@assets/icons/AssetPlaceholder/WebsitePlaceHolder-v2.svg?url';
import { ReactComponent as NotSupportedImgSvg } from '@assets/icons/AssetPlaceholder/unsupported.svg';
import { ReactComponent as AudioPlaceHolderSvg } from '@assets/icons/AssetPlaceholder/audiofile.svg';
import { ReactComponent as VideoPlaceHolderSvg } from '@assets/icons/AssetPlaceholder/videofile.svg';
import { ReactComponent as DocumentPlaceHolderSvg } from '@assets/icons/AssetPlaceholder/pdffile.svg';
import { ReactComponent as WebsitePlaceHolderSvg } from '@assets/icons/AssetPlaceholder/website.svg';

export function previewThumbnailsByType(
  type: string,
  size?: number,
  format?: 'svg' | 'img'
) {
  switch (type) {
    case 'audio':
      return format === 'svg' ? (
        <AudioPlaceHolderSvg width={size} height={size} />
      ) : (
        AudioPlaceHolder
      );
    case 'video':
      return format === 'svg' ? (
        <VideoPlaceHolderSvg width={size} height={size} />
      ) : (
        VideoPlaceHolder
      );
    case 'raster_image':
    case 'camera_raw_image':
    case 'vector_image':
    case 'document':
    case 'presentation':
    case 'spreadsheet':
      return format === 'svg' ? (
        <DocumentPlaceHolderSvg width={size} height={size} />
      ) : (
        DocumentPlaceHolder
      );
    case 'website':
      return format === 'svg' ? (
        <WebsitePlaceHolderSvg width={size} height={size} />
      ) : (
        WebsitePlaceHolder
      );
    default:
      return format === 'svg' ? (
        <NotSupportedImgSvg width={size} height={size} />
      ) : (
        NotSupportedImg
      );
  }
}

export function assetPreviewThumbnails({
  url,
  status,
  type,
  size = 40,
  format = 'svg',
  showPendingPlaceholder = false
}: {
  url: string | null | undefined;
  status: string;
  type: string;
  size?: number;
  format?: 'svg' | 'img';
  showPendingPlaceholder?: boolean;
}): string {
  if (showPendingPlaceholder && status === 'pending')
    return previewThumbnailsByType(type, size, format);

  if (status === 'pending') return 'pending';

  if (status === 'ready') {
    return url || previewThumbnailsByType(type, size, format);
  }
  return previewThumbnailsByType(type, size, format);
}
